<template>
  <google-map
    :center="center"
    :zoom="5"
    :circles.sync="circles"
    :markers="markers"
    :selectors="[employeeTypeSelector, employeeRoleSelector]"
    :map-height="mapHeight"
  />
</template>
  
  <script>
  import GoogleMap from '@hw-ui/components/maps/GoogleMap.vue'
  import {getUsersByLocation} from '@/shared/services/userService'
  
  
  export default {
      components: {
          GoogleMap,
      },
      props: {
            title: {
                type: String,
                default: '',
            },
            mapHeight: {
                type: Number,
                default: 200,
            },
            users: {
                type: Array,
                required: false,
                default: () => [],
            },
      },
      data() {
          return {
          markers: [],
          center: {
              lat: 60.60730350000001,
              lng: 24.8239116,
          },
          circles: [
          ],
          employeeTypeSelector: {
              title: 'Työntekijät/Hakijat',
              id: 1,
              selectorOptions: {
                  clearable: false,
                  multiple: false,
              },
              options: [
              {
                  label: 'Työntekijät',
                  value: 'tyontekijat',
              },
              {
                  label: 'Hakijat',
                  value: 'hakijat',
              }
              ],
              selected: 'tyontekijat',
            },
            employeeRoleSelector: {
              title: 'Rooli',
              id: 2,
              selectorOptions: {
                  clearable: true,
                  multiple: true,
                  width: '100%',
              },
              options: this.$store.state.appAccount.roles.map(role => ({
                      label: role.label,
                      value: role.label,
                  })),
              selected: null,
            },
          }
      },
      watch: {
          circles: {
              handler() {
                  this.getUsers()
              },
              deep: true,
          },
          employeeTypeSelector: {
              handler() {
                  this.getUsers()
              },
              deep: true,
          },
          employeeRoleSelector: {
              handler() {
                  this.getUsers()
              },
              deep: true,
          },
      },
      created() {
          this.getUsers()
      },
      methods: {
         getUsers() {
              this.markers = []
              let matchedUsers = []
              const roles = this.employeeRoleSelector.selected
              const employeeType = this.employeeTypeSelector.selected
              this.circles.map(async circle => {
                  const result = await getUsersByLocation(circle.center, circle.radius, employeeType, roles)
                  // Filter out users that are already in the list
                  const users = result.filter(user => !matchedUsers.find(u => u.id === user.id))
                  matchedUsers = [...matchedUsers, ...users]
  
                  this.markers = matchedUsers.map(user => ({
                      lat: user.address.gps.lat,
                      lng: user.address.gps.lng,
                  }))
                  this.$emit('update:users', matchedUsers)
              })
          },
      },
  }
  </script>